import { api, privateAxios } from "../../../config/apiConfig";
import { removeCartItem } from "../Cart/Action";
import { CREATE_PAYMENT_FAILURE, CREATE_PAYMENT_REQUEST, CREATE_PAYMENT_SUCCESS, UPDATE_PAYMENT_FAILURE, UPDATE_PAYMENT_SUCCESS } from "./ActionType";


export const createPayment = (orderId, cart) => async (dispatch) => {
    dispatch({ type: CREATE_PAYMENT_REQUEST })
    try {
        const { data } = await privateAxios.post(`user/payment/${orderId}`);
        if (data.status === "SUCCESS") {
            dispatch({ type: CREATE_PAYMENT_SUCCESS, payload: data })
            cart?.cartItems?.forEach((item) => dispatch(removeCartItem(item.id)));
        }
    } catch (error) {
        dispatch({ type: CREATE_PAYMENT_FAILURE, payload: error.message })
    }
}

export const updatePayment = (reqData) => async (dispatch) => {
    dispatch({ type: UPDATE_PAYMENT_SUCCESS })
    try {
        const { data } = await api.get(`user/payments?payment_id=${reqData.paymentId}&order_id=${reqData.orderId}`)

    } catch (error) {
        dispatch({ type: UPDATE_PAYMENT_FAILURE, payload: error.message })
    }
}